/**
 * 10.9CT — PAINEL DEV (só em import.meta.env.DEV). Botão flutuante 🛠️ que abre uma coluna de
 * botões pra testar o jogo no extremo: subir nível, forja máxima, recursos, spawnar monstros/boss,
 * god mode, dano ×N e RESETAR TUDO (limpa o save e recarrega pra recomeçar o teste). NÃO entra no
 * build de produção (o Game só instancia isto sob DEV). Puro DOM.
 */
export interface DevButton {
  label: string | (() => string);
  fn: () => void;
  danger?: boolean;
}
export interface DevGroup {
  title: string;
  buttons: DevButton[];
}

export class DevPanel {
  private readonly root: HTMLDivElement;
  private readonly panel: HTMLDivElement;
  private open = false;
  private readonly refreshers: (() => void)[] = [];

  constructor(groups: DevGroup[]) {
    this.root = document.createElement("div");
    this.root.id = "dev-panel";
    const toggle = document.createElement("button");
    toggle.className = "dev-toggle";
    toggle.textContent = "🛠️";
    toggle.title = "Painel DEV";
    toggle.onclick = () => this.setOpen(!this.open);
    this.panel = document.createElement("div");
    this.panel.className = "dev-body";
    this.panel.hidden = true;

    const head = document.createElement("div");
    head.className = "dev-head";
    head.innerHTML = "<span>🛠️ DEV</span>";
    const close = document.createElement("button");
    close.className = "dev-x";
    close.textContent = "✕";
    close.onclick = () => this.setOpen(false);
    head.appendChild(close);
    this.panel.appendChild(head);

    for (const g of groups) {
      const sec = document.createElement("div");
      sec.className = "dev-sec";
      const t = document.createElement("div");
      t.className = "dev-sec-t";
      t.textContent = g.title;
      sec.appendChild(t);
      const row = document.createElement("div");
      row.className = "dev-row";
      for (const b of g.buttons) {
        const el = document.createElement("button");
        el.className = "dev-btn" + (b.danger ? " danger" : "");
        const setLabel = (): void => { el.textContent = typeof b.label === "function" ? b.label() : b.label; };
        setLabel();
        this.refreshers.push(setLabel);
        el.onclick = () => { b.fn(); this.refreshAll(); };
        row.appendChild(el);
      }
      sec.appendChild(row);
      this.panel.appendChild(sec);
    }

    this.root.appendChild(toggle);
    this.root.appendChild(this.panel);
    document.body.appendChild(this.root);
    this.injectStyle();
  }

  private refreshAll(): void { for (const r of this.refreshers) r(); }

  private setOpen(v: boolean): void {
    this.open = v;
    this.panel.hidden = !v;
    if (v) this.refreshAll();
  }

  private injectStyle(): void {
    if (document.getElementById("dev-panel-style")) return;
    const s = document.createElement("style");
    s.id = "dev-panel-style";
    s.textContent = `
#dev-panel { position: fixed; left: 6px; top: calc(90px + env(safe-area-inset-top, 0px)); z-index: 99999; font: 600 12px system-ui, sans-serif; }
#dev-panel .dev-toggle { width: 38px; height: 38px; border-radius: 10px; border: 1px solid #6b3fd6; background: rgba(20,12,40,.85); color: #fff; font-size: 18px; cursor: pointer; }
#dev-panel .dev-body { margin-top: 6px; width: 208px; max-height: 74vh; overflow-y: auto; background: rgba(14,10,26,.96); border: 1px solid #6b3fd6; border-radius: 12px; padding: 8px; box-shadow: 0 8px 30px rgba(0,0,0,.5); }
#dev-panel .dev-head { display: flex; justify-content: space-between; align-items: center; color: #c9a8ff; font-weight: 800; margin-bottom: 6px; }
#dev-panel .dev-x { background: none; border: none; color: #b9b3d6; font-size: 14px; cursor: pointer; }
#dev-panel .dev-sec { margin-bottom: 8px; }
#dev-panel .dev-sec-t { color: #8f86b8; font-size: 10px; text-transform: uppercase; letter-spacing: .05em; margin: 4px 0; }
#dev-panel .dev-row { display: flex; flex-wrap: wrap; gap: 5px; }
#dev-panel .dev-btn { flex: 1 1 auto; min-width: 60px; padding: 8px 6px; border-radius: 8px; border: 1px solid rgba(255,255,255,.18); background: rgba(255,255,255,.06); color: #eae6ff; cursor: pointer; }
#dev-panel .dev-btn:active { transform: scale(.96); }
#dev-panel .dev-btn.danger { border-color: #e5484d; background: linear-gradient(180deg, rgba(229,72,77,.35), rgba(120,30,40,.5)); color: #ffb3b5; }
`;
    document.head.appendChild(s);
  }
}
